import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { type ImageRulesType } from 'utils/apiList/images'

import {
  BannerComponentOptionType,
  HomeTabComponentDetailType,
  HomeTabComponentStateType,
  HomeTabComponentTypeOptionType,
} from 'features/MultiCategory/@types/homeTabComponent'

export const SLICE_NAME = 'multiCategoryHomeTabComponent'

export const initialState: HomeTabComponentStateType = {
  isLoading: false,
  isSubmitting: false,
  detail: null,
  bannerOptions: [],
  isBannerOptionsLoading: false,
  selectedBannerOptions: [],
  componentTypeOptions: [],
  isComponentTypeOptionsLoading: false,
  tileImageRule: null,
}

const multiCategoryHomeTabComponent = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setIsSubmitting: (state, { payload }: PayloadAction<boolean>) => {
      state.isSubmitting = payload
    },
    setDetail: (state, { payload }: PayloadAction<HomeTabComponentDetailType | null>) => {
      state.detail = payload
    },
    setBannerOptions: (state, { payload }: PayloadAction<BannerComponentOptionType[]>) => {
      state.bannerOptions = payload
    },
    setIsBannerOptionsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isBannerOptionsLoading = payload
    },
    /** Adds or refreshes banners resolved by id, keeping the ones already cached. */
    upsertSelectedBannerOptions: (
      state,
      { payload }: PayloadAction<BannerComponentOptionType[]>,
    ) => {
      const merged = [...state.selectedBannerOptions]

      payload.forEach((banner) => {
        const index = merged.findIndex((item) => item.id === banner.id)

        if (index === -1) {
          merged.push(banner)
        } else {
          merged[index] = banner
        }
      })

      state.selectedBannerOptions = merged
    },
    setComponentTypeOptions: (
      state,
      { payload }: PayloadAction<HomeTabComponentTypeOptionType[]>,
    ) => {
      state.componentTypeOptions = payload
    },
    setIsComponentTypeOptionsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isComponentTypeOptionsLoading = payload
    },
    setTileImageRule: (state, { payload }: PayloadAction<Nullable<ImageRulesType>>) => {
      state.tileImageRule = payload
    },
  },
})

export const {
  resetState,
  setIsLoading,
  setIsSubmitting,
  setDetail,
  setBannerOptions,
  setIsBannerOptionsLoading,
  upsertSelectedBannerOptions,
  setComponentTypeOptions,
  setIsComponentTypeOptionsLoading,
  setTileImageRule,
} = multiCategoryHomeTabComponent.actions
export default multiCategoryHomeTabComponent.reducer
